import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bus-seat-status',
  templateUrl: './bus-seat-status.component.html',
  styleUrls: ['./bus-seat-status.component.scss'],
})
export class BusSeatStatusComponent implements OnInit {
  @Input() status = '';

  constructor() {}

  ngOnInit(): void {}
}
